import React, { useState, useEffect, useRef } from "react";
import Helper from "../../common/helper";
import ApiService from "../../services/api.service";
import LoadingScreen from "../../common/loader";

import "./payment.css";
import { Accordion, Sidebar } from "flowbite-react";

import PaymentMethod from '../UI/payment-method'
import { useNavigate, useSearchParams } from "react-router";
import Spinner from '../../common/spinner';

import TagManager from "react-gtm-module";
// import ErrorComponent from '../../components/UI/error';
import StepsIndicator from "../steps-indicator";
import IconVisa from "../../assets/images/payment-visa-v2.png";
import IconMasterCard from "../../assets/images/payment-mastercard-v2.png";
import IconAmex from "../../assets/images/payment-amex-v2.png";
import BackButton from "../UI/back-button";
import PaymentScreen from "../UI/payment-screen";
import PaymentLogos from "../UI/payment-logos";

const queryParams = new URLSearchParams(window.location.search);

function Payment({
  isDirectLink,
  isPaymentScreen,
  loadPaymentMethodStep,
  paymentName,
  goBacktoPaymentMethod,
  goPreviousStep,
  selectMembership,
  currentStep,
  isRenewalPage,
  locationData,
  languages,
  localStorageDatas,
  businessCategories,
  goNextStep,
  couponObj,
  businesscategory,
  category,
  isUserLogged,
  subsidiary,
}) {
  
  const [error, setError] = useState(null);
  const [isLoaded, setIsLoaded] = useState(false);
  const [total, setTotal] = useState();

  const [headerText, setHeaderText] = useState("");
  const [step, setStep] = useState(1); // Wizard Step state

  const [paymentMethods, setPaymentMethods] = useState({});
  const [ap_transaction_id, setTransactionId] = useState("");

  // const [nbPoints, setNbPoints]                 = useState(50000); // FOR LOCAL TESTING PWP WITH POINTS
  const [nbPoints, setNbPoints] = useState(0);
  const [nbPointsAccepted, setNbPointsAccepted] = useState();

  const [memberId, setMemberId] = useState();
  const [pmid, setPmid] = useState();
  //const [price_level_text, setPriceLevelText] = useState();

  const [searchParams, setSearchParams] = useSearchParams();
  const [pwpBc, setPwpBc] = useState(false);

  const [userStatus, setUserStatus] = useState();
  const [orderItemsError, setOrderItemsError] = useState();

  const [pwpUserData, setPwpUserData] = useState({});


  const navigate = useNavigate();
  const [businessCategoryState, setBusinessCategoryState] = useState();

  const triggeredAlready = useRef(false);
  const [loadPaymentMethod, setLoadPaymentMethod] = useState([]);

  var pwpData;
  var price_level_text = null;
  let selected_product_bc = null;

  //set members here
  let primaryMember = {};
  let isTraveller;

  let member;

  for (let i = 0; i < localStorageDatas.members.length; i++) {
    member = localStorageDatas.members[i];
    pwpData = Helper.newpwpCheck(
      member.selected_product[0],
      isUserLogged,
      locationData,
      businessCategories
    );
    if (
      member.type_of_member == "primary_owner" &&
      member.phone_number !== undefined &&
      member.phone_number
    ) {
      var phoneNum =
        member.phone_number.localNumber === null
          ? member.phone_number
          : member.phone_number.localNumber;
      primaryMember = {
        firstname: member.first_name,
        lastname: member.last_name,
        email: member.email,
        phone: phoneNum,
        lead_id: 0,
        memberid: member.memberid,
        pmid: member.pmid || "",
      };

      if (
        member.selected_product &&
        member.selected_product[0] &&
        member.selected_product[0].business_category_id
      ) {
        //setPriceLevelText(localStorageDatas[member.selected_product[0].business_category_id]);
        price_level_text =
          localStorageDatas.business_categories[
            member.selected_product[0].business_category_id
          ]?.price_level_text;
        selected_product_bc = member.selected_product[0].business_category_id;
      }
    }
  }
  let HOTEL_DETECTED = false;
  let pricelevel = "";
  var pArr = [];
  var logosArr = [IconVisa, IconMasterCard, IconAmex];

  useEffect(() => {
    if (triggeredAlready.current) return;
    triggeredAlready.current = true;
    loadMemberPoints();
    let payment = locationData.PaymentMethod;
    let arrangedPayment = [];

    if (pwpData.isPWPExclusive) {
      payment = {
        PayWithPoints: payment["PayWithPoints"],
      };
    }

    // check if pay with points
    if (!pwpBc && pwpData.exists && !member.selected_product[0].isQbr) {
      // if(loadPaymentMethod) {
      //     updateCurrentPaymentMethodActive() // if pwp is enabled
      // }
      Object.keys(payment)?.map((key, index) => {
        if (key === "PayWithPoints") {
          arrangedPayment[key] = payment[key];
        }
      });

      Object.keys(payment)?.map((key, index) => {
        if (key != "PayWithPoints") {
          arrangedPayment[key] = payment[key];
        }
      });
    } else {
      arrangedPayment = payment;
    }

    setPaymentMethods(arrangedPayment);

    //check userStatus here
  }, [pwpBc]);

  useEffect(() => {
    loadPaymentMethodArray();
  }, [paymentMethods]);

  function loadPaymentMethodArray() {
    Object.keys(paymentMethods)?.map((item, index) => {
      if (paymentMethods[item].Enabled) {
        if (paymentMethods[item].pMethod?.length > 0) {
          return paymentMethods[item].pMethod?.map((key) => {
            var itemArr = {
              name: key.pmCode,
              show: false,
            };
            pArr.push(itemArr);
          });
        } else {
          var itemArr = {
            name: item,
            show: false,
          };
          pArr.push(itemArr);
        }
      }
    });
    let updatedPmethod = pArr.map((item, index) => {
      if (index === 0) {
        return {
          ...item,
          show: true,
        };
      } else {
        return {
          ...item,
        };
      }
    });
    setLoadPaymentMethod(updatedPmethod);
  }

  async function loadMemberPoints() {
    let userSource;
    let userDataResult;
    try {
      userDataResult = await ApiService.userdata();
      if (window.dataLayer.filter((a) => a.checkoutStep === 2).length < 1) {
        TagManager.dataLayer(
          Helper.gtmFunnelPage(
            locationData.currency,
            2,
            userDataResult ? userDataResult.card.cardLabel : category,
            window.location.pathname,
            "",
            productsForGtm()
          )
        );
      }
      let userData = {
        firstName: userDataResult.firstName,
        lastName: userDataResult.lastName,
        salutation: userDataResult.salutation,
        currentTiering: userDataResult.card?.currentTiering,
      };
      setPwpUserData(userData);

      //Check for PWP BC through localStorageDatas.business_categories
      setPwpBc(getPwpBc(localStorageDatas.business_categories));
      //Disable PWP tab for renewals
      //Check for PRIMARY MEMBER only
      let primaryOwner = getPrimaryOwnerMember(localStorageDatas.members);

      ApiService.memberStatus(
        { email: primaryOwner.email },
        locationData.emailCheck
      )
        .then((res) => res.json())
        .then((result) => {
          if (userStatus === "MEMBER-Current Member") {
            setUserStatus(result);
            setPwpBc(false);
            setNbPointsAccepted(false);
          }
        });

      let sumPoints = sumMembershipPoints();

      //Get supp length
      let suppLength = getSuppLength(localStorageDatas.members);
      //Check if selected product from primary_owner have points_value

      let pointsObj = userDataResult?.card?.points;
      // console.log('pointsObj', pointsObj);
      // console.log('pwp sum points', sumPoints)
      // console.log('pointsObj', pointsObj && pointsObj <= 0);
      //let pointsObj = userDataResult.loyalty.balances.nbPoints;

      // check if 0 points does it go to else if
      // check the else statement

      if (suppLength > 0) {
        // ('pwp- with supp')
        setPwpBc(true);
        setNbPointsAccepted(true);
      } else if (sumPoints.points === 0) {
        // check
        // console.log('pwp- pwp has no points')
        setPwpBc(false);
        setNbPointsAccepted(false);
      } else if (pointsObj && pointsObj <= 0) {
        // console.log('pwp- 0 points')
        setNbPoints(userDataResult.loyalty.balances.nbPoints);
        // setNbPoints(5000);
        setNbPointsAccepted(true);
      } else {
        // console.log('pwp- check')
        setPmid(userDataResult?.pmid);
        if (pmid) {
          userSource = "cookie";
        }

        setNbPoints(pointsObj);

        if (pointsObj >= sumPoints.points) {
          // console.log('pwp- is accepted')
          setNbPointsAccepted(true);
        } else {
          // console.log('pwp- not accepted')
          setNbPointsAccepted(false);
        }
      }
    } catch (err) {
      console.error("error :: loadMemberPoints()", err);
    }

    let itemsArr = getItems();

    if (localStorageDatas.hotelRIDOnlineKiosk) {
      HOTEL_DETECTED = true;
    }

    let primaryOwner = getPrimaryOwnerMember(localStorageDatas.members);

    if (!pmid) {
      setPmid(primaryOwner.pmid);
      userSource = "local";
    }


    let userCookieOverride = null;
    if (!pmid && userDataResult && userDataResult.pmid) {
      userCookieOverride = userDataResult.pmid;
      userSource = "override";
    }

    //Create parameters to prepare for the transaction
    let transactionParams = {
      pricelevel: price_level_text,
      subsidiary: locationData.subsidiary,
      // "subsidiary": subsidiary, // subsidiary detection
      firstname: primaryMember.firstname || null,
      lastname: primaryMember.lastname || null,
      email: primaryMember.email || null,
      phone: primaryMember.phone || null,
      lead_id: 0,
      hotelRIDOnlineKiosk: localStorageDatas.hotelRIDOnlineKiosk || "",
      apHotelEmployeeName: localStorageDatas.apHotelEmployeeName || "",
      hotelEmployee: localStorageDatas.hotelEmployee || "",
      apHotelEmployeeId: localStorageDatas.apHotelEmployeeId || "",
      pmid: pmid || userCookieOverride,
      // "pmid"   : pmid || "",
      source: HOTEL_DETECTED ? "Hotel" : "Website",
      userSource: userSource,
    };

    let data = getTransactionId(transactionParams, itemsArr);
    //transactionId = data.ap_transaction_id;
  }

  function getPrimaryOwnerMember(members) {
    let member = {};

    for (let i = 0; i < members.length; i++) {
      member = members[i];
      if (member.type_of_member == "primary_owner") {
        return member;
      }
    }
    return false;
  }

  function getSuppLength(members) {
    let suppLength = 0;
    for (let i = 0; i < members.length; i++) {
      let member = members[i];
      if (member.type_of_member == "supp") {
        suppLength++;
      }
    }
    return suppLength;
  }

  function getPwpBc(business_categories) {
    for (let businessCategoryId in business_categories) {
      if (
        business_categories[businessCategoryId].points_type_id &&
        business_categories[businessCategoryId].points_type_text
      ) {
        //this is the points business category
        return true;
      }
    }
    return false;
  }

  function sumMembershipPoints() {
    /*let result = selectMembership.reduce((accumulator, obj) => {
            return accumulator + parseInt(obj.points_value);
          }, 0);*/
    let pointsChecker = {
      exists: false,
      points: "",
      public_points_table_id: "",
      post_pay_override: false,
      points_business_category_id: "",
    };
    for (let i = 0; i < localStorageDatas.members.length; i++) {
      let member = localStorageDatas.members[i];
      if (member.type_of_member == "primary_owner") {
        if (member.selected_product[0].isQbr) {
          member.selected_product[0].points_table_options?.map(
            (item, index) => {
              // check if product has points table and return the points
              // if (item.points_provider_id == "1" && item.points_type_id == "2") {
              if (item.points_provider_id && item.points_type_id) {
                if (item.points_type_text.toUpperCase() == "POINTS EARNED") {
                  // QBR
                  return (pointsChecker = {
                    exists: true,
                    points: item.points_value,
                    public_points_table_id: item.public_points_table_id,
                    post_pay_override: item.post_pay_override,
                    points_business_category_id:
                      item.points_business_category_id,
                    isQbr: true,
                  });
                }
              }
            }
          );
        } else {
          member.selected_product[0].points_table_options?.map(
            (item, index) => {
              // check if product has points table and return the points
              // console.log('item selected', item)
              // if (item.points_provider_id == "2" && item.points_type_id == "1") {
              if (item.points_provider_id && item.points_type_id) {
                if (item.points_type_text.toUpperCase() == "POINTS CONSUMED") {
                  // PWP
                  return (pointsChecker = {
                    exists: true,
                    points: item.points_value,
                    public_points_table_id: item.public_points_table_id,
                    post_pay_override: item.post_pay_override,
                    points_business_category_id:
                      item.points_business_category_id,
                  });
                }
              } else {
                return (pointsChecker = {
                  exists: false,
                  points: "",
                  public_points_table_id: "",
                  post_pay_override: false,
                });
              }
            }
          );
        }
        // points = pointsChecker.points
      }
    }
    // console.log('member points', pointsChecker)
    return pointsChecker;
  }

  async function getTransactionId(transactionParams, itemsArr) {
    let sumPoints = sumMembershipPoints();

    const response = await ApiService.createTransaction(transactionParams);

    if (
      !response.ap_transaction_id &&
      response.errorMessage &&
      response.errorType == "string"
    ) {
      setError(response.errorMessage);
      return;
    }

    setTransactionId(response.ap_transaction_id);
    let primaryOwner = getPrimaryOwnerMember(localStorageDatas.members);

    //Create parameters to prepare to create order items
    couponObj =
      couponObj && couponObj.length > 0 ? JSON.parse(couponObj) : couponObj;
    let orderItemsParams = {
      ap_transaction_id: response.ap_transaction_id,
      subsidiary:
        couponObj && couponObj.length > 0
          ? couponObj.subsidiary_id
          : locationData.subsidiary,
      // "subsidiary" : (couponObj && couponObj.length > 0) ? couponObj.subsidiary_id : subsidiary, //subsidiary detecion
      language: "en-au",
      pmid: pmid || primaryOwner.pmid || "",
      items: itemsArr,
      coupon_code: couponObj ? couponObj.coupon_code_id : "",
    };

    if (!Array.isArray(couponObj) && couponObj) {
      orderItemsParams["bc"] = couponObj.business_category_id;
    } else if (searchParams.get("bc")) {
      orderItemsParams["bc"] = searchParams.get("bc");
    } else {
      //orderItemsParams["bc"] = (searchParams && searchParams.get("bc") ? searchParams.get("bc") : locationData.defaultPriceLevel)
      orderItemsParams["bc"] =
        businesscategory ||
        searchParams.get("bc") ||
        selected_product_bc ||
        locationData.defaultPriceLevel;
    }

    if (searchParams.get("pricelevel")) {
      let pricelevel = searchParams.get("pricelevel");
      //console.log("price_level_text", pricelevel);
      orderItemsParams["pricelevel"] =
        pricelevel || price_level_text || locationData.defaultPriceLevel;
      orderItemsParams["bc"] = getBcWithPriceLevel(pricelevel);
      //console.log('orderItemsParams["bc"]', orderItemsParams["bc"]);
    }

    if (sumPoints.exists || Helper.isQbr(locationData)) {
      orderItemsParams["public_points_table_id"] =
        sumPoints.public_points_table_id;
    }

    if ((sumPoints.exists && sumPoints.isQbr) || Helper.isQbr(locationData)) {
      orderItemsParams["bc"] = sumPoints.points_business_category_id;
    }

    setBusinessCategoryState(orderItemsParams["bc"]);

    //Create the orderitems in the database
    let data = getOrderItems(response.ap_transaction_id, orderItemsParams);
  }

  function getBcWithPriceLevel(pricelevel) {
    for (let bc in businessCategories) {
      if (pricelevel == businessCategories[bc].price_level_text) {
        return businessCategories[bc].business_category_id;
      }
    }
    return false;
  }

  function extractTotal(response) {
    if (response.statusCode !== 200) {
      setError(response.body);
    }
    if (typeof response !== "object" || response === null) return null;

    let parseBody = response.body;

    if (typeof parseBody === "string") {
      try {
        parseBody = JSON.parse(parseBody);
        return parseBody;
      } catch {
        return null;
      }
    }

    // If response has a "body" as a string, parse it
    // if (response.body && typeof response.body === "string") {
    //     try {
    //         response = { ...response, body: JSON.parse(response.body) };
    //     } catch {
    //         return null; // Invalid JSON
    //     }
    // }

    // Extract total value from either format
    // const total = response.total ?? response.body?.total;
    // return typeof total === "number" ? { total } : null;
  }

  async function getOrderItems(transactionId, orderItemsParams) {
    try {
      const response = await ApiService.createOrderItems(
        transactionId,
        orderItemsParams
      );

      // have a checker for prod and staging for different response types.
      // const orderItemBody = JSON.parse(response.body);

      const orderItemBody = extractTotal(response);

      // console.log("Order Item Body: ", orderItemBody);

      // if(orderItemBody.errorMessage) {
      //     setError("Error: " + response.errorMessage);
      //     // throw new Error("Error: " + response.errorMessage)
      //     // return <ErrorComponent/>
      // } else
      if (orderItemBody.order_complete === true) {
        goNextStep(transactionId, null, null, navigate);
        return;
      }
      // var total = response?.total;
      var total = orderItemBody.total;

      // if(total === undefined) {
      //     total = orderItemBody.total
      // }

      setTotal(total);
      setIsLoaded(true);
      // This is where we check the complimentary.
      let ssoUserData = await ApiService.userdata();
      if (window.dataLayer.filter((a) => a.checkoutStep === 3).length < 1) {
        TagManager.dataLayer(
          Helper.gtmFunnelPage(
            locationData.currency,
            3,
            ssoUserData ? ssoUserData.card.cardLabel : category,
            window.location.pathname,
            "",
            productsForGtm()
          )
        );
      }
      return response;
    } catch (err) {
      console.log(err);
      setError("Error: " + err.errorMessage);
    }
  }

  function productsForGtm() {
    let products = [];
    for (let i = 0; i < localStorageDatas.members.length; i++) {
      let member = localStorageDatas.members[i];
      products.push({
        id: member.selected_product[0].item_group_id,
        name: member.selected_product[0].item_group_description,
        price:
          parseFloat(member.selected_product[0].purchase_price) +
          parseFloat(
            member.selected_product[0].tax_amt ||
            member.selected_product[0].tax_amount
          ),
      });
    }

    return products;
  }

  function getItems() {
    let itemsArr = [];
    let primaryOwner = getPrimaryOwnerMember(localStorageDatas.members);

    for (let i = 0; i < localStorageDatas.members.length; i++) {
      let member = localStorageDatas.members[i];

      //member.memberid = "";
      //primaryOwner.memberid = "";
      if (!member.memberid || !primaryOwner.memberid) {
        setError(
          "ErrCode (1014) : Member ID not generated. Please go back and try again."
        );
      }

      itemsArr.push({
        ns_member_id: member.memberid,
        parent_member_id: primaryOwner.memberid,
        item_group_id:
          member.selected_product &&
            member.selected_product[0] &&
            member.selected_product[0].item_group_id
            ? member.selected_product[0].item_group_id
            : "",
        digital_card: !member.card,
        bc: member.selected_product[0].business_category_id,
      });
    }

    if (itemsArr.length > 0) {
      primaryMember["member_id"] = itemsArr[0].parent_member_id;
      setMemberId(itemsArr[0].parent_member_id);
    }
    return itemsArr;
  }

  const [activeCurrentIndex, setActiveCurrentIndex] = useState(1);
  const toggleShowAccordion = (id, paymentMethodStr) => {
    setActiveCurrentIndex(id);
    if (loadPaymentMethod) {
      let updatePaymentMethodLoad = loadPaymentMethod.map((item, index) => {
        if (item.name === paymentMethodStr) {
          return {
            ...item,
            show: true,
          };
        } else {
          return {
            ...item,
          };
        }
      });
      setLoadPaymentMethod(updatePaymentMethodLoad);
    }
  };

  // const [isPaymentScreen, setIsPaymentScreen] = useState(false)
  // const [paymentName, setPaymentName] = useState("")

  // const loadPaymentMethodStep = (method) => {
  //     console.log('method', method)
  //     setPaymentName(method)
  //     setIsPaymentScreen(true)
  // }

  // const goBacktoPaymentMethod = () => {
  //     setIsPaymentScreen(false)
  // }

  let BC = queryParams.get("bc");
  let pMethod = locationData.PaymentMethod.PayWithPoints;
  let pMethodBC = pMethod ? pMethod.bc : null;
  let bcExist = false;

  Object.values(businessCategories)?.map((business_category, index) => {
    // loop through BCS
    if (
      pMethodBC &&
      pMethodBC.includes(business_category.business_category_id) &&
      !Helper.isQbr(locationData)
    ) {
      bcExist = true; //if PWP BC has the business category id
    }
  });
  let item_selected = localStorageDatas.members?.[0].selected_product;
  const membershipItem = Object.values(item_selected)[0].item_group_description;

  if (error) {
    console.log("Error order items:", error);
    throw new Error(error);
  }

  if (!isLoaded) {
    return (
      <div class="flex content-center justify-center">
        <Spinner />
      </div>
    );
  } else {
    let idCounter = 0;
    return (
      <>
        {isPaymentScreen ? (
          <PaymentScreen
            goPreviousStep={goBacktoPaymentMethod}
            currentStep={currentStep}
            paymentName={paymentName}
            loadPaymentMethod={loadPaymentMethod}
            transactionId={ap_transaction_id || ""}
            member={localStorageDatas.members || {}}
            locationData={locationData}
            directLink={false}
            nbPoints={nbPoints}
            enoughNbPoints={nbPointsAccepted}
            goNextStep={goNextStep}
            total={total}
            localStorageDatas={localStorageDatas}
            memberId={memberId}
            accordionIndex={idCounter}
            // toggleShowAccordion={toggleShowAccordion}
            toggleShowAccordion={loadPaymentMethodStep}
            activeCurrentIndex={activeCurrentIndex}
            price_level_text={price_level_text}
            pwpBcEnabled={pwpBc}
            pmid={pmid}
            bcState={businessCategoryState}
            pwpData={pwpData}
            isUserLogged={isUserLogged}
            isRenewalPage={isRenewalPage}
            languages={languages}
            isPwpPointsEnabled={sumMembershipPoints()}
            isDirectLink={isDirectLink}
            membershipItem={membershipItem}
            pwpUserData={pwpUserData}
          />
        ) : (
          <div>
            {/* <BackButton goPreviousStep={goPreviousStep}/>                     */}
            <div id="accordion-wrapper">
              <div className="holder-title">
                {/* <StepsIndicator step={currentStep} stepText={"Payment"} subTitleHeader={"Pay your Accor Plus Explorer Membership"}/> */}
                <p className="payment-subtitle font-montserrat font-medium font-semibold">
                  {languages && languages.selectPaymentMethod
                    ? languages.selectPaymentMethod
                    : "Select your payment method"}
                  :{" "}
                </p>
              </div>
              <div>
                {Object.keys(paymentMethods)?.map((mainKey, mainIndex) => {
                  // console.log('check here 3 mainKey', paymentMethods)
                  if (paymentMethods[mainKey].Enabled) {
                    if (paymentMethods[mainKey].pMethod?.length > 0) {
                      return paymentMethods[mainKey].pMethod?.map((key) => {
                        idCounter++;
                        return (
                          <PaymentMethod
                            pwpEnabled={false}
                            keys={key.pmCode}
                            loadPaymentMethod={loadPaymentMethod}
                            pmName={key.pmCode}
                            transactionId={ap_transaction_id || ""}
                            member={localStorageDatas.members || {}}
                            locationData={locationData}
                            index={mainKey}
                            directLink={true}
                            nbPoints={nbPoints}
                            enoughNbPoints={nbPointsAccepted}
                            goNextStep={goNextStep}
                            total={total}
                            localStorageDatas={localStorageDatas}
                            memberId={memberId}
                            accordionIndex={idCounter}
                            // toggleShowAccordion={toggleShowAccordion}
                            toggleShowAccordion={loadPaymentMethodStep}
                            activeCurrentIndex={activeCurrentIndex}
                            price_level_text={price_level_text}
                            pwpBcEnabled={pwpBc}
                            pmid={pmid}
                            bcState={businessCategoryState}
                            pwpData={pwpData}
                            isUserLogged={isUserLogged}
                            isRenewalPage={isRenewalPage}
                            languages={languages}
                            isPwpPointsEnabled={sumMembershipPoints()}
                          />
                        );
                      });
                    } else {
                      idCounter++;
                      return (
                        <PaymentMethod
                          key={mainKey}
                          pmName={mainKey}
                          loadPaymentMethod={loadPaymentMethod}
                          transactionId={ap_transaction_id || ""}
                          member={localStorageDatas.members || {}}
                          locationData={locationData}
                          index={mainIndex}
                          directLink={false}
                          nbPoints={nbPoints}
                          enoughNbPoints={nbPointsAccepted}
                          goNextStep={goNextStep}
                          total={total}
                          localStorageDatas={localStorageDatas}
                          memberId={memberId}
                          accordionIndex={idCounter}
                          // toggleShowAccordion={toggleShowAccordion}
                          toggleShowAccordion={loadPaymentMethodStep}
                          activeCurrentIndex={activeCurrentIndex}
                          price_level_text={price_level_text}
                          pwpBcEnabled={pwpBc}
                          pmid={pmid}
                          bcState={businessCategoryState}
                          pwpData={pwpData}
                          isUserLogged={isUserLogged}
                          isRenewalPage={isRenewalPage}
                          languages={languages}
                          isPwpPointsEnabled={sumMembershipPoints()}
                        />
                      );
                    }
                  }
                })}
                <PaymentLogos
                  title={
                    languages && languages.securePayment
                      ? languages.securePayment
                      : "Secure payment"
                  }
                  logos={logosArr}
                  style={"mx-1"}
                />
              </div>
            </div>
          </div>
        )}
      </>
    );
  }
}

export default Payment;
